var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4159_3729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.40005C23.496 2.40005 29.6 8.50405 29.6 16C29.6 23.496 23.496 29.6 16 29.6C8.50405 29.6 2.40005 23.496 2.40005 16C2.40005 8.50405 8.50405 2.40005 16 2.40005ZM16 0.800049C7.60805 0.800049 0.800049 7.60805 0.800049 16C0.800049 24.392 7.60805 31.2 16 31.2C24.392 31.2 31.2 24.392 31.2 16C31.2 7.60805 24.392 0.800049 16 0.800049Z",
    fill: "#353EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.832 23.6799C11.696 23.6799 11.552 23.6479 11.432 23.5759C11.184 23.4319 11.032 23.1679 11.032 22.8799V9.11992C11.032 8.83192 11.184 8.56792 11.432 8.42392C11.68 8.27992 11.984 8.27992 12.232 8.42392L24.152 15.3039C24.4 15.4479 24.552 15.7119 24.552 15.9999C24.552 16.2879 24.4 16.5519 24.152 16.6959L12.232 23.5759C12.112 23.6479 11.968 23.6799 11.832 23.6799ZM12.632 10.5039V21.4959L22.152 15.9999L12.632 10.5039Z",
    fill: "#353EBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4159_3729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartCircle);
export default __webpack_public_path__ + "static/media/start-circle.1aa223dabff5d04a06f6aa920ae7fabc.svg";
export { ForwardRef as ReactComponent };